import apiUrl from "../../../../utils/settings";

export const getPWAMainMenuUrl = () => {
    return apiUrl + `/external-system/pwa-main-menu`;
};

export const getPWASubMenuUrl = () => {
    return apiUrl + `/external-system/pwa-sub-menu`;
};
  